var render = function render(){
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('RouterLink', {
    class: (_class = {}, _class[_vm.$style.footerItem] = true, _class[_vm.$style.active] = _vm.active, _class),
    attrs: {
      "to": _vm.route
    }
  }, [_vm.active ? _c('span', {
    class: _vm.$style.topBorder
  }) : _vm._e(), _c('MottoIcon', {
    class: _vm.$style.footerIcon,
    attrs: {
      "name": _vm.icon,
      "icon-color": _vm.active ? 'primary' : 'slate'
    }
  }), _c('p', {
    class: (_class2 = {}, _class2[_vm.$style.footerLabel] = true, _class2['tag-text'] = _vm.active, _class2.p2 = !_vm.active, _class2)
  }, [_vm._v(_vm._s(_vm.label))])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }